import "./project-dashboard.scss";

import { ProjectContext, TProjectContext } from "context/ProjectProvider";
import { useContext, useEffect, useMemo } from "react";
import { EUserTypes } from "constants/index";
import { Spin } from "antd";
import { matchUserProjectRole } from "utils/utils";
import { useHistory, useParams } from "react-router";
import useCheckVersionUpdates from "hooks/check-version-updates";
import GCProjectDashboard2 from "./gc-project-dashboard2";
import SCProjectDashboard from "./sc-project-dashboard/sc-project-dashboard";

import OwnerProjectDashboard from "./owner-project-dashboard/owner-project-dashboard";
import ArchitectProjectDashboard from "./architect-project-dashboard/architect-project-dashboard";

function ProjectDashboard() {
  const { projectId } = useParams() as any;
  const history = useHistory();

  const { tokenContents }: TProjectContext = useContext(ProjectContext);

  useCheckVersionUpdates({
    autoCheckInIntervals: false
  });

  const isCurrentUserGC = matchUserProjectRole(
    EUserTypes.GENERAL_CONTRACTOR,
    tokenContents?.role
  );

  const isCurrentUserSC = matchUserProjectRole(
    EUserTypes.SUBCONTRACTOR,
    tokenContents?.role
  );

  const isCurrentUserArchitect = matchUserProjectRole(
    EUserTypes.ARCHITECT,
    tokenContents?.role
  );

  const isCurrentUserOwner = matchUserProjectRole(
    EUserTypes.OWNER,
    tokenContents?.role
  );

  useEffect(() => {
    if (
      tokenContents?.role &&
      !isCurrentUserGC &&
      !isCurrentUserSC &&
      !isCurrentUserArchitect &&
      !isCurrentUserOwner
    ) {
      history.replace(`/project/${projectId}/submittals`);
    }
  }, [
    history,
    isCurrentUserArchitect,
    isCurrentUserGC,
    isCurrentUserOwner,
    isCurrentUserSC,
    projectId,
    tokenContents?.role
  ]);

  const dashboardRenderer = useMemo(() => {
    if (isCurrentUserGC) {
      return <GCProjectDashboard2 />;
    }

    if (isCurrentUserSC) {
      return <SCProjectDashboard />;
    }

    if (isCurrentUserArchitect) {
      return <ArchitectProjectDashboard />;
    }

    if (isCurrentUserOwner) {
      return <OwnerProjectDashboard />;
    }

    return (
      <div className="h-full flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }, [
    isCurrentUserGC,
    isCurrentUserSC,
    isCurrentUserArchitect,
    isCurrentUserOwner
  ]);

  return (
    <div className="h-full w-full project-dashboard">{dashboardRenderer}</div>
  );
}

export default ProjectDashboard;
